<template>
    <li class="list__items__item " :class="{'list__items__item--group-title':title}">
        <span class="list__items__item__label" :class="{'smart': !title}">{{ label }}</span>
        <span v-if="value.value" class="list__items__item__value">{{ value.value }} {{ value.unit ? value.unit : '' }}</span>
    </li>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        title: {
            type: Boolean,
            required: true
        },
        smart: {
            type: Boolean,
            required: false
        }
    }
}

</script>

<style scoped lang="scss">
.list {
      grid-area: var(--grid-area);

      &__title {          
          text-align: left;
          padding: 0;
          display: flex;
          align-items: center;

        &__icon {
          height: 1.6rem;          
          margin-right: 0.3rem;
          min-width: 1.2rem;
        }

        &__value {
          border-bottom: 1px solid #000;
          width: 100%;
          padding-bottom: 2px;
        }
      }

      &__items {
        list-style-type: none;
        margin: 0;
        padding: 0;
        margin-left: 1.2rem;

        &__item {
          display: flex;
          justify-content: space-between;
          text-align: left;
          

          &__value {
            font-weight: 500;
          }

          &--group-title {
            padding-left: unset;
            margin-top: 0.3rem;
          }

          .smart {
            padding-left: 1.2rem;
          }
        }
      }
    }
</style>


// WEBPACK FOOTER //
// src/views/Offer/Summary/SummaryItem.vue